import React from 'react'
import MenuLink from './link'
import './nav.css'

const Navigation = ({gov_care_registration, base_url, done}) => (
  <menu className="navigation">
    <MenuLink name="registration" valid={!gov_care_registration} to={base_url}>Registration</MenuLink>
    <MenuLink name="details" valid={gov_care_registration && !done} to={base_url}>Details</MenuLink>
    <MenuLink name="nominate" valid={gov_care_registration && !done} to={base_url + '/nominate'}>Nominate</MenuLink>
    <MenuLink name="done" valid={done} to={base_url + '/nominate'}>Done</MenuLink>
  </menu>
)

export default Navigation


// WEBPACK FOOTER //
// ./src/onboarding/nav/views/index.jsx